import { DefaultChannel } from '../../config'
import { parseQueryString, saveChannelId, getLocalChannelId } from './index'

const params = parseQueryString(window.location.search)
const cid = params.pid || params.cid
const ocid = getLocalChannelId()
if (cid || !ocid) {
    saveChannelId(cid ? cid.replace('--instart', '') || DefaultChannel : DefaultChannel)
}